import { captureException, configureScope } from '@sentry/nextjs'

import { isServer } from '../utils/platform-utils'
import CookieManagerService from './cookie-manager-service'

// This gets initialised in sentry.[server/client].config.js
class ErrorTrackingService {
    public captureException(err?: any, ctx?: any) {
        configureScope(scope => {
            if (err.message) {
                // De-duplication currently doesn't work correctly for SSR / browser errors
                // so we force deduplication by error message if it is present.
                scope.setFingerprint([err.message])
            }

            if (err.statusCode) {
                scope.setExtra('statusCode', err.statusCode)
            }

            if (ctx) {
                const { req, res, errorInfo, query, pathname } = ctx

                if (res && res.statusCode) {
                    scope.setExtra('statusCode', res.statusCode)
                }

                if (!isServer) {
                    scope.setTag('ssr', 'false')
                    scope.setExtra('query', query)
                    scope.setExtra('pathname', pathname)
                } else {
                    scope.setTag('ssr', 'true')
                    scope.setExtra('url', req.url)
                    scope.setExtra('method', req.method)
                    scope.setExtra('headers', req.headers)
                    scope.setExtra('params', req.params)
                    scope.setExtra('query', req.query)
                }

                // We use Cookie Manager Service to fetch the device session ID.
                const deviceSessionID = CookieManagerService.getCookie(CookieManagerService.DEVICE_SESSION_ID, req)
                if (deviceSessionID) {
                    scope.setUser({ id: deviceSessionID })
                }

                if (errorInfo) {
                    Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]))
                }
            }

            return captureException(err)
        })
    }
}

export default new ErrorTrackingService()
